export const monthlyStatement = [
  {
    heading: "21 Oct 24",
    subHeading: "Date",
  },
  {
    heading: "October",
    subHeading: "Month",
  },
  {
    heading: "25",
    subHeading: "No.of Transactions",
  },
  {
    heading: "$1,321",
    subHeading: "Total Commission",
  },
];
